import { models as startModels,stores } from '@kurtosys/app-start';
import { models } from '@kurtosys/ksys-app-components';
import { IManifest } from '@kurtosys/types/appsManager/index.js';
import { action, computed, makeObservable, observable } from 'mobx';

import { LIBRARY_COMPONENTS_CONFIGURATION } from '../../../configuration/libraryComponentsConfiguration.js';
import { MockData } from '../../../configuration/mockData/index.js';
import { IComponentStyles, IConfiguration, TStoreContext } from '../../../models';
import { LineChartStore } from '../../LineChart/stores/LineChartStore.js';
import { Feature } from '../../shared/Feature.js';
import { IAppComponents } from '../models/IAppComponents';
type IAppDevelopmentConfig = startModels.IAppDevelopmentConfig;
type IGlobalConfiguration = models.IGlobalConfiguration;

/* [Component: appStoreComponentImport] */
let devConfig: IAppDevelopmentConfig = {
	applicationClientConfigurationIds: null,
	applicationClientConfigurations: null,
	authentication: null,
	configuration: null,
	styles: null,
	libraryComponentsConfiguration: LIBRARY_COMPONENTS_CONFIGURATION,
};

if (process.env.NODE_ENV !== 'production') {
	devConfig = {
		...devConfig,
		applicationClientConfigurationIds: async () => {
			const { APPLICATION_CLIENT_CONFIGURATION_IDS } = await import(
				'../../../configuration/development.applicationClientConfigurationIds.js'
			);
			return APPLICATION_CLIENT_CONFIGURATION_IDS;
		},
		applicationClientConfigurations: async () => {
			const { APPLICATION_CLIENT_CONFIGURATIONS } = await import(
				'../../../configuration/development.applicationClientConfigurations.js'
			);
			return APPLICATION_CLIENT_CONFIGURATIONS;
		},
		authentication: async () => {
			const { AUTHENTICATION } = await import('../../../configuration/development.authentication.js');
			return AUTHENTICATION;
		},
		configuration: async () => {
			const { CONFIGURATION } = await import('../../../configuration/development.config.js');
			return CONFIGURATION;
		},
		styles: async () => {
			const { STYLES } = await import('../../../configuration/development.styles.js');
			return STYLES;
		},
	};
}

export class AppStore extends stores.base.AppStoreBase<IConfiguration, IComponentStyles> {
	@observable lineChartHasData = false;
	constructor(
		element: HTMLElement,
		url: string,
		storeContext: TStoreContext,
		manifest: IManifest,
		mockData?: MockData,
	) {
		super(element, url, storeContext, manifest, Feature, devConfig, mockData);
		makeObservable(this);
	}

	@computed
	get lineChartStore() {
		return this.storeContext.get<LineChartStore>('lineChartStore');
	}
	@computed
	get hasData(): boolean {
		return this.lineChartStore.hasData;
	}

	@action
	contextsDidUpdateAfter = async () => {
		// TODO: Each Application should put custom logic here to handle changes to the data context
	};

	@computed
	get components(): IAppComponents {
		return {
			/* [Component: appStoreComponent] */
		};
	}

	@computed
	get globalConfiguration(): IGlobalConfiguration | undefined {
		return this.libraryComponentsConfiguration && this.libraryComponentsConfiguration.global;
	}

	async customInitializeAfter() {
		if (this.lineChartStore) {
			await this.lineChartStore.initialize();
		}
	}
}
